export const companyInfo = {
  name: "Sydthy Taxi & Turistfart ApS",
  cvr: "37610151",
  phone: "21 30 90 70",
  email: "sydthyflex@gmail.com",
  locations: [
    {
      address: "Vestergårdsvej 2",
      city: "7755 Bedsted Thy",
      mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2218.432109876543!2d8.345678!3d56.789012!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x464a1234567890ab%3A0x1234567890abcdef!2sVesterg%C3%A5rdsvej%202%2C%207755%20Bedsted%20Thy!5e0!3m2!1sda!2sdk!4v1234567890123"
    },
    {
      address: "Ringvejen 63",
      city: "7900 Nykøbing Mors",
      mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2218.432109876543!2d8.845678!3d56.789012!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x464a1234567890ab%3A0x1234567890abcdef!2sRingvejen%2063%2C%207900%20Nyk%C3%B8bing%20Mors!5e0!3m2!1sda!2sdk!4v1234567890123"
    }
  ]
};

export const navigation = [
  { name: "Forside", href: "/" },
  { name: "Om os", href: "/om-os" },
  { name: "Turistkørsel", href: "/ydelser/turist" },
  { 
    name: "Taxa", 
    href: "/taxa",
    subItems: [
      { name: "Taxa priser", href: "/taxa/taxa-priser" },
      { name: "Beregn din pris", href: "/taxa/taxa-priser#beregn-pris" }
    ]
  },
  { name: "Kontakt", href: "/kontakt" },
];

export const services = [
  {
    id: "turist",
    title: "Turistkørsel",
    description: "Eksklusive busrejser og udflugter i ind- og udland med fokus på komfort og sikkerhed.",
    longDescription: "Planlægger du et arrangement hvor der er behov for transport af deltager? Så kontakt os og lad os hjælpe med planlægningen, så I får den helt rigtige løsning med turistkørsel.",
    image: "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/939e332a-d433-4b42-9dc2-33c2a4ff985e.jpg",
    features: ["Luksusbusser", "Aircondition & Toilet", "Erfarne rejsechauffører", "Skræddersyede ture"]
  },
  {
    id: "taxa",
    title: "Taxa",
    description: "Bestil nemt og hurtigt en taxa i Thy og på Mors. Vi står til rådighed døgnet rundt.",
    longDescription: "Vi forstår, at behovet for transport kan opstå på alle tidspunkter af døgnet, og derfor står vores taxaer til rådighed døgnet rundt. Uanset om det er tidligt om morgenen, sent om aftenen eller midt om natten, kan du regne med sikker transport til tiden.",
    image: "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/98dd9867-410a-47f4-b860-f333f9cd9dba.jpg",
    features: ["Døgnåbent 24/7", "Professionelle chauffører", "Hurtig fremmøde", "Konkurrencedygtige priser"]
  }
];

export const homepageFocusBoxes = [
  {
    id: "om-os",
    title: "Om os",
    description: "Lær mere om vores historie, værdier og dedikerede team af chauffører.",
    href: "/om-os",
    image: "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/b1e10660-3989-4dce-a006-f3d474cb3e0c.jpg"
  },
  {
    id: "turist",
    title: "Turistkørsel",
    description: "Eksklusive busrejser og udflugter i ind- og udland med fokus på komfort.",
    href: "/ydelser/turist",
    image: "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/939e332a-d433-4b42-9dc2-33c2a4ff985e.jpg"
  },
  {
    id: "taxa",
    title: "Taxa",
    description: "Bestil nemt og hurtigt en taxa i Thy og på Mors. Vi kører 24/7.",
    href: "/taxa",
    image: "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/98dd9867-410a-47f4-b860-f333f9cd9dba.jpg"
  },
  {
    id: "taxa-priser",
    title: "Taxa priser",
    description: "Se vores gennemskuelige takster for både små og store taxaer.",
    href: "/taxa/taxa-priser",
    image: "https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/f0f0c8ec-4417-4341-bc1d-7d4354979c8f.jpg"
  }
];

export const testimonials = [
  {
    name: "Jens Jensen",
    role: "Foreningsformand",
    content: "Vi har brugt Sydthy Taxi til vores årlige udflugter i flere år. Altid top professionelt og bilerne er i perfekt stand."
  },
  {
    name: "Mette Nielsen",
    role: "Privatkunde",
    content: "Fantastisk service da vi skulle bruge transport til min datters konfirmation. Chaufføren var utrolig hjælpsom."
  },
  {
    name: "Erik Hansen",
    role: "Erhvervskunde",
    content: "Pålidelig partner til vores medarbejdertransport. De overholder altid aftalerne."
  }
];
